/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';
import { clearSelectSoData } from '../../redux/actions/salesOrderActions';
import APP_CONSTANTS from '../../config/constants';
import { connect } from 'react-redux';

const BillingPartyDropdown = ({
    field: { name },
    form: { setFieldValue },
    getBranchData,
    getVendorDetails,
    getBillingCustomerInvoice,
    getCustomerSalesOrder,
    setCustomerName,
    getVehicleData,
    setInitialize,
    getCustomerDetails,
    customerMasterCode,
    setLastOptions,
    SOPagination,
    ...props
}) => {

    const [customerData, setCustomerData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        if (customerData.length == 1) {
            if (getCustomerDetails != null && getCustomerDetails != undefined) {
                getCustomerDetails(customerData[0])
            }
        }
    }, [customerData])

    useEffect(() => {
        if (customerMasterCode) {
            setIsLoading(true)
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo
                })

            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/billing_party?customerNumber=${customerNo}&userId=${userId}`, {
                params: {
                    "billingPartyCode": customerMasterCode
                },
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setCustomerData(response.data.resultSet)
                setIsLoading(false)
            }))
                .catch(error => console.log(error))
            setIsLoading(false)
        }
    }, [])


    let options = []
    if (customerData && customerData.length > 0) {
        customerData.map((object, index) => {
            let temp = {}
            temp.key = index
            temp.text = object.billingPartyName
            temp.value = object.billingPartyCode
            return options[index] = temp
        })
    }

    const handleOnChange = (e, data) => {
        if (data.value) {
            let test = customerData.forEach((object) => {
                if (data.value == object.billingPartyCode) {
                    if (getCustomerDetails != null && getCustomerDetails != undefined) {
                        getCustomerDetails(object)
                    }
                }
            })
        }
        setInitialize && setInitialize(true)
        setFieldValue(name, data.value)
        setCustomerName && setCustomerName(data.value)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        let customerObject = customerData.filter(e => {
            return e.billingPartyCode === data.value
        })
        props.setCustomerCode && props.setCustomerCode(data.value)
        getBillingCustomerInvoice && getBillingCustomerInvoice(data.value).then(() => { setInitialize(false) })
        getCustomerSalesOrder && SOPagination == true ? getCustomerSalesOrder(10, '', 1, data.value, '', '', true).then(() => { setInitialize(false) }) : getCustomerSalesOrder && getCustomerSalesOrder(data.value).then(() => { setInitialize(false) })

        props.clearSelectSoData()

        if (data.value) {
            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/billing_party_branch/?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${customerObject && customerObject?.length > 0 && customerObject[0]?.billingPartyId} `, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then((response => {
                    getBranchData(response.data.resultSet)
                    setIsLoading(false)
                }))
                .catch((error => {
                    console.log(error)
                    setIsLoading(false)
                }))
        }
    }

    const handleSearchChange = (e, { searchQuery }) => {

        if (searchQuery.length > 1) {
            setIsLoading(true)
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')
            let data = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo,
                    "searchString": searchQuery
                })

            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/billing_party?customerNumber=${customerNo}&userId=${userId}`, {
                params: {
                    "searchString": searchQuery
                },
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setCustomerData(response.data.resultSet)
                setIsLoading(false)
            }))
                .catch(error => console.log(error))
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (options?.length > 0 && setLastOptions) {
            setLastOptions(options)
        }
    }, [options])

    if (props?.defaultOptions && props?.defaultOptions?.length > 0) {
        options = props.defaultOptions
    }

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            onSearchChange={handleSearchChange}
            options={options}
            clearable
            loading={isLoading}
            {...props}
            fluid
        />
    )
}



const mapStatetoProps = (state) => ({
    clearSelectSoData
})

export default connect(mapStatetoProps, { clearSelectSoData })(BillingPartyDropdown)